export default "__VITE_ASSET__5f426f31__"